
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useSurpriseItemList } from '@/modules/surprise/category/item/model/list';
import { ROUTE_NAME_SURPRISE } from '@/modules/surprise/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_SURPRISE.CATEGORY.ITEM.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, query, fetchList, actions, categoryId } = useSurpriseItemList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Price', key: 'price' },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.Boolean, label: 'Is Published', key: 'isPublished' },
                { type: TableColumnType.Text, label: 'Total Sale', key: 'totalSale' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_SURPRISE.CATEGORY.ITEM.EDIT, params: { categoryId, itemId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, categoryId, ROUTE_NAME_SURPRISE };
    }
});
